export default __webpack_public_path__ + "static/tv_display-df01ad79944a5b6147df41effde84722.jpg";